import { FC, Props } from "./typings";
import styles from "./styles.module.scss";
import { useContext, useState } from "react";
import Button from "components/Button";
import ModalsManagerContext from "contexts/ModalsManager";
import { SettingsTabs } from "components/Settings/SettingsModal";
import CloseIcon from "assets/icons/close.svg?react";
import InfoIcon from "assets/icons/info.svg?react";
import VideoUrl from "../../../public/video/encrypted.mp4?url";
import { Modal, Tooltip } from "@mui/material";
import { useTranslation } from "react-i18next";

const ContactMessageConfiguration: FC<Props> = ({ toggle }) => {
  const { t } = useTranslation();
  const { modals, setModals, setOptions } = useContext(ModalsManagerContext);
  const [showVideo, setShowVideo] = useState<boolean>(false);
  const handleClick = () => {
    toggle();
    setOptions({
      initialTab: SettingsTabs.PACKAGE,
    });
    setModals({ ...modals, settings: true });
  };

  return (
    <div className={styles.settingsWrapper}>
      <div className={styles.settings}>
        <div className={styles.title}>
          {t("packages.enableEncrypted")}
          <CloseIcon onClick={() => toggle()} className={styles.closeIcon} />
        </div>
        <>
          <div className={styles.sub}>
            {t("packages.configureEncryptedHint")}{" "}
            <Tooltip title={t("common.help")} className={styles.visible}>
              <span className={styles.infoIcon}>
                <InfoIcon
                  onClick={(e) => {
                    e.preventDefault();
                    e.stopPropagation();
                    setShowVideo(!showVideo);
                  }}
                />
              </span>
            </Tooltip>
          </div>

          {
            <div className={styles.btnWrapper}>
              <Button
                className={styles.btn}
                onClick={() => {
                  handleClick();
                }}
                text={t("packages.activateEncrypted")}
              />
            </div>
          }
        </>
      </div>

      <Modal
        open={showVideo}
        onClose={() => setShowVideo(false)}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <div className={styles.modal}>
          <div className={styles.header}>
            {t("common.help")}
            <CloseIcon
              className={styles.closeIcon}
              onClick={(e) => {
                setShowVideo(false);
                e.stopPropagation();
              }}
            />
          </div>
          <div className={styles.body}>
            <video autoPlay loop muted className={styles.video}>
              <source src={VideoUrl} type="video/mp4" />
              {t("errors.browserVideoUnsupported")}
            </video>
          </div>
        </div>
      </Modal>
    </div>
  );
};

export default ContactMessageConfiguration;
